import React from 'react';
import { findWithUUID } from '@/utils/uuidHelper';
import { isSplitUrl, joinUrl, splitUrl } from '@/constants/urls';
import InEditCell from '@/components/table/InEditCell';
import { updateLookupItemProperties, updateLookupProperties } from '../../dictionaries/actions';
import { datasetPermissions } from '../../sharing/constants';

const LookupValueContainer = ({
  exists,
  canRead,
  children,
}) => (
  <InEditCell
    exists={exists}
    canRead={canRead}
  >
    {children}
  </InEditCell>
);

const accessControl = (role, exists, perms) => (
  {
    canEdit: exists ? role.permissions.datasets.update
      && perms[datasetPermissions.UPDATE] : false,
    canRead: exists ? role.permissions.datasets.read : false,
    exists,
  }
);

const withoutItem = (role) => (
  {
    ...accessControl(role, false),
  }
);

const withItem = (lookups, lookup, item, role) => {
  const uri = isSplitUrl(item.uri) ? item.uri : splitUrl(item.uri);

  return ({
    ...accessControl(role, true, lookups.permissions),
    description: item.description,
    isEditing: lookups.isEditing,
    name: item.name,
    options: lookup.options,
    saveErrors: lookups.saveErrors,
    uri: joinUrl(uri),
    uriLink: uri.link,
    uriProtocol: uri.protocol,
    validationWarnings: lookups.validationWarnings,
    dictionaryUUID: lookups.activeDictionaryUUID,
    activeLookupName: lookups.activeLookupName,
  });
};

export const mapStateToProps = ({
  auth: { role },
  datasets: { lookups },
}, { lookupItemUUID }) => {
  const dictionary = findWithUUID(lookups.dictionaries, lookups.activeDictionaryUUID);
  const lookup = dictionary ? dictionary.lookups[lookups.activeLookupName] || { options: [] } : { options: [] };
  const item = findWithUUID(lookup.options, lookupItemUUID || '');

  return item ? withItem(lookups, lookup, item, role) : withoutItem(role);
};

export const mapDispatchToProps = {
  updateProperties: updateLookupItemProperties,
  updatePropertiesLookup: updateLookupProperties,
};

export default LookupValueContainer;
